import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const PhoneCarousel = ({ screens = [], name = "", accent = "#0B1F3A" }) => {
  const [index, setIndex] = useState(0);
  const multi = screens.length > 1;

  useEffect(() => {
    if (!multi) return;
    const id = setInterval(() => setIndex((i) => (i + 1) % screens.length), 4000);
    return () => clearInterval(id);
  }, [multi, screens.length]);

  return (
    <div className="relative flex flex-col items-center">
      <div className="relative w-full max-w-sm overflow-hidden rounded-[2rem] border border-white/20 shadow-2xl animate-float-slow">
        <AnimatePresence mode="wait">
          <motion.img
            key={index}
            src={screens[index]}
            alt={`Aperçu de l'application ${name}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="w-full h-auto block"
          />
        </AnimatePresence>
        <div className="pointer-events-none absolute inset-0 rounded-[2rem] ring-1 ring-inset ring-white/40" />
      </div>

      {multi && (
        <div className="mt-5 flex items-center gap-2">
          {screens.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              data-testid={`screen-dot-${i}`}
              aria-label={`Écran ${i + 1}`}
              className={`h-1.5 rounded-full transition-all duration-500 ${i === index ? "w-8" : "w-4 bg-white/40 hover:bg-white/60"}`}
              style={i === index ? { backgroundColor: accent, width: "2rem" } : undefined}
            />
          ))}
        </div>
      )}
    </div>
  );
};
